module.exports = __webpack_public_path__ + "static/media/9.Mathni Machine.ceefe601.jpg";